import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ThermostatAutoIcon(props: IconProps) {
    return <Icon {...props} iconKey={"thermostat_auto"}/>
}
